export const menuPhoneSubmenuControl = () => {
  const headerElement = document.querySelector('.js-header') as HTMLElement

  const menusWrapper = document.querySelector('.js-menu-mainWrapper') as HTMLElement

  const menuTitle = document.querySelector('.js-menu-mainTitle') as HTMLElement

  // Kill this if the header element is not found
  if (!headerElement || !menuTitle || !menusWrapper) { return }

  menuTitle.addEventListener('click', () => {
    const windowWidth = window.innerWidth

    if (windowWidth <= 768) {
      if (menusWrapper.classList.contains('-isCollapsed')) {
        menusWrapper.classList.remove('-isCollapsed')
      } else {
        menusWrapper.classList.add('-isCollapsed')
      }
    }
  })
}
